type ButtonVariant = "primary" | "outline" | "ghost" | "danger";
type ButtonSize = "default" | "small" | "hero";

interface ButtonProps {
  children: React.ReactNode;
  variant?: ButtonVariant;
  size?: ButtonSize;
  href?: string;
  onClick?: () => void;
  className?: string;
  type?: "button" | "submit";
}

export default function Button({
  children,
  variant = "primary",
  size = "default",
  href,
  onClick,
  className = "",
  type = "button",
}: ButtonProps) {
  const classes = [
    "btn",
    variant !== "primary" ? `is-${variant}` : '',
    size !== "default" ? `is-${size}` : '',
    className,
  ]
    .filter(Boolean)
    .join(" ");

  if (href) {
    return (
      <a className={classes} href={href}>
        {children}
      </a>
    );
  }

  return (
    <button className={classes} type={type} onClick={onClick}>
      {children}
    </button>
  );
}
